export function parseIntStrict(v: unknown): number {
    const str = typeof v !== 'string' ? String(v ?? '') : v;
    const m = str.match(/^[+\-]?\d+/);
    if (!m) return NaN;
    const num = Number(m[0]);
    return Number.isFinite(num) ? num : NaN;
}
